
import { Component, OnInit } from '@angular/core';
import { NotificationService, ROUTE_ANIMATIONS_ELEMENTS } from '@cradua/core';
import { ApprovalLevelDto } from '@cradua/data';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';
import { Observable } from 'rxjs';

@Component({
  selector: 'cradua-approval-level-container',
  templateUrl: './approval-level-container.component.html',
  styleUrls: ['./approval-level-container.component.scss']
})
export class ApprovalLevelContainerComponent implements OnInit {

  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  approvallevels$: Observable<ApprovalLevelDto[]>;
  loading: boolean;
  isLoading$:  Observable<any>;
  constructor(
    private gatwayFacade: GatewayFacade,
    private notificationService: NotificationService
  ) {}

  ngOnInit() {
    this.isLoading$ = this.gatwayFacade.isLoadingGateway("ApprovalLevel");
    this.approvallevels$ = this.gatwayFacade.loadGateway("ApprovalLevel");
  }

/**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteApprovalLevel(deletedValue: any) {
    this.gatwayFacade.remove("ApprovalLevel", deletedValue);
    // this.store.dispatch(ApprovalLevelStoreActions.removeApprovalLevel({ids: deletedValue}));
    this.notificationService.success('Deleted Successfully');
  }


// this method control both the create and update

  onSubmitApprovalLevel(formValue: any) {
    formValue.ApprovalLevels = formValue.ApprovalLevels.reverse();
    const pullData = formValue.ApprovalLevels;
    //const newPullData = formValue.ApprovalLeveles;

// declare two empty array to hold update and create data
  let allUpdates = [] ;
  let addAllApprovalLevel = [];


// loop through the form data to check for update and create

  for(let i = 0; i < pullData.length; i++) {
    if(pullData[i].id) {
      allUpdates.push(pullData[i]);
    } else {
      delete pullData[i].id;
      addAllApprovalLevel.push(pullData[i]);
    }
  }

// check if the addAllApprovalLevel array is not empty, then dispatch the data to the store
   if(addAllApprovalLevel.length !== 0) {
    this.gatwayFacade.add('ApprovalLevel', addAllApprovalLevel);
    // this.store.dispatch(ApprovalLevelStoreActions.addApprovalLevel({newApprovalLevel: addAllApprovalLevel}));

   }

// dispatch update data to the store
this.gatwayFacade.update('ApprovalLevel', allUpdates, ['id']);
    // this.store.dispatch(ApprovalLevelStoreActions.updateApprovalLevel({updateApprovalLevel: allUpdates}));
    this.notificationService.success('Saved Successfully');
  }
}
